<template>
    <div>
        <MaPatientinfo />
    </div>
</template>

<script>
import MaPatientinfo from "./maPatientinfoView.vue";
export default {
    components: {
        MaPatientinfo,
    },
    data() {
        return{
            
        }
    },
    created(){
        
    }
};
</script>
